import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { productService } from "services/product.api";
import { setProductItems } from "store/productSlice";
import { selectProductItems } from "store/productSlice";

const useProduct = () => {
  const dispatch = useDispatch();
  const productList = useSelector(selectProductItems);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getProductList = async (data) => {
    setLoading(true);
    try {
      const response = await productService.fetchList(data);
      if (response.success) {
        dispatch(setProductItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const createProduct = async (payload) => {
    setLoading(true);
    try {
      const response = await productService.createProduct(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const updateProduct = async (id, payload) => {
    setLoading(true);
    try {
      const response = await productService.updateProduct(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const deleteProduct = async (id) => {
    setLoading(true);
    try {
      const response = await productService.deleteProduct(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getProductById = async (id) => {
    setLoading(true);
    try {
      const response = await productService.fetchProductById(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    getProductList,
    productList,
    createProduct,
    getProductById,
    deleteProduct,
    updateProduct,
    loading,
    error,
  };
};

export default useProduct;
